// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ThumbUpIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ThumbUp/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M14 14h4.764a2 2 0 0 0 1.789-2.894l-3.5-7A2 2 0 0 0 15.263 3h-4.017a2 2 0 0 0-.485.06L7 4m7 10v5a2 2 0 0 1-2 2h-.095a.905.905 0 0 1-.905-.904c0-.715-.211-1.413-.608-2.008L7 13V4m7 10h-2M7 4H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2.5"
}));
export default ThumbUpIcon;